import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { merge, noop } from 'rxjs';
import {delay} from 'rxjs/operators';
import {LoadingService} from './common/global-spinner/loading.service';
import { RouteReuseHelperService } from './services/route-reuse-helper.service';
import { WsService } from './services/ws.service';
import { mergeMap } from 'rxjs/operators';

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
	title = "gestionale-gp";

	@ViewChild("siteContainer") siteContainer: ElementRef;

	loading: boolean = false;
	lastLoading: boolean = false;
	lastSched: number = 0;

	constructor(private _loading: LoadingService, private router:Router, private rrh : RouteReuseHelperService) {
        router.events.forEach((event) => {
            if(event instanceof NavigationEnd) {
                const URL = router.url;
                if(URL.includes("/list")){
                    rrh.shouldReFilter.next(true);
                }
            }
          });
    }

	ngOnInit() {
		this.listenToLoading();
	}

	listenToLoading(): void {
		this._loading.loadingSub
			.pipe(delay(0))
			.subscribe((loading) => {
				this.lastLoading = loading;

				if (loading) this.adjustLoading(true);
				else this.setNotLoadingLater();
			});
	}

	private adjustLoading(isLoading: boolean) {
		this.loading = isLoading;
		this.siteContainer.nativeElement.setAttribute(
			"class",
			this.loading ? "site-container loading" : "site-container"
		);
	}

	private setNotLoadingLater() {
		var fn = (n) => {
			setTimeout(() => {
				if (this.lastSched == n && !this.lastLoading) this.adjustLoading(false);
			}, 250);
		};

		fn(++this.lastSched);
	}
}
